// extracted by mini-css-extract-plugin
export default {"heading":"SponsorLogo_heading__iDX8Q","logo":"SponsorLogo_logo__PXNlP"};